import API from '../';
import { HTTP_METHODS } from '../helpers/methods-helpers';

class StructureAPI extends API {
	getAllStrucutre(pagination, currentPage) {
		const paginationUrl = pagination
			? `?registrosPorPagina=${pagination}&numeroDePagina=${currentPage}`
			: '';

		return this.requestWrapper(
			this.request({
				url: `${this.scheme}${paginationUrl}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}
	getFileName(currentFileName) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/versionArchivo?id_entidad=0&nombreArchivo=${currentFileName}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}
}

export const structureAPI = new StructureAPI('/archivos/ESTRUCTURA');
